// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  const variant = evt.detail.variant;
  const textAboveVariants = document.querySelectorAll('.text-above-variants');

  if (textAboveVariants.length > 0) {
    textAboveVariants.forEach(function(element) {
      element.classList.add('hidden');
    });

    if (variant && variant.id) {
      const currentVariantText = document.querySelector('.text-above-variants[data-variant-id="' + variant.id + '"]');
      if (currentVariantText) {
        currentVariantText.classList.remove('hidden');
      }
    }
  }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {});
// Restore the selected variant's gallery order.
// The product gallery renders one node per unique media (dedup keeps the page
// small on high-variant bundles), so DOM order follows a media's first
// appearance across variants rather than the order in the selected variant's
// image_gallery metafield. The section ships the real per-variant order in
// [data-variant-gallery-order]; reorder the shared nodes to match it.
(function () {
  var orderMap;

  function getOrderMap() {
    if (orderMap) return orderMap;
    var el = document.querySelector("[data-variant-gallery-order]");
    try {
      orderMap = el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      orderMap = {};
    }
    return orderMap;
  }

  function groupByParent(nodes) {
    var groups = [];
    nodes.forEach(function (node) {
      var group = groups.filter(function (g) {
        return g.parent === node.parentNode;
      })[0];
      if (!group) {
        group = { parent: node.parentNode, nodes: [] };
        groups.push(group);
      }
      group.nodes.push(node);
    });
    return groups;
  }

  function applyOrder(group, getId, rank) {
    var nodes = group.nodes;
    if (nodes.length < 2) return;
    var sorted = nodes.slice().sort(function (a, b) {
      var ra = rank[getId(a)];
      var rb = rank[getId(b)];
      return (ra === undefined ? Infinity : ra) - (rb === undefined ? Infinity : rb);
    });
    var unchanged = sorted.every(function (node, i) {
      return node === nodes[i];
    });
    if (unchanged) return;
    // Keep the block in place: re-insert where the last node currently sits.
    var after = nodes[nodes.length - 1].nextSibling;
    var frag = document.createDocumentFragment();
    sorted.forEach(function (node) {
      frag.appendChild(node);
    });
    group.parent.insertBefore(frag, after && after.parentNode === group.parent ? after : null);
  }

  function reorderForVariant(variantId) {
    var order = getOrderMap()[variantId];
    if (!order || order.length < 2) return;

    var rank = {};
    order.forEach(function (mediaId, i) {
      rank[String(mediaId)] = i;
    });

    var mediaNodes = [].slice.call(document.querySelectorAll('[id^="product_media_shared_"]'));
    groupByParent(mediaNodes).forEach(function (group) {
      applyOrder(group, function (node) {
        return node.getAttribute("data-media-item-id");
      }, rank);
    });

    var thumbButtons = [].slice.call(
      document.querySelectorAll('[id^="product_thumbnails__item_button_shared_"]')
    );
    var thumbItems = thumbButtons
      .map(function (btn) {
        return btn.closest(".product-thumbnails__item");
      })
      .filter(Boolean);
    groupByParent(thumbItems).forEach(function (group) {
      applyOrder(group, function (item) {
        var btn = item.querySelector("[data-thumbnail-id]");
        return btn && btn.getAttribute("data-thumbnail-id");
      }, rank);
    });

    requestAnimationFrame(refreshSwipers);
  }

  function refreshSwipers() {
    [window.mainSwiper, window.thumbnailSwiper].forEach(function (swiper) {
      if (!swiper || typeof swiper.update !== "function") return;
      swiper.update();
      if (swiper.updateSlides) swiper.updateSlides();
      if (swiper.updateSlidesClasses) swiper.updateSlidesClasses();
    });
    document.querySelectorAll(".swiper").forEach(function (el) {
      if (el.swiper && el.closest(".product__media-container")) el.swiper.update();
    });
  }

  function currentVariantId() {
    var fromUrl = new URLSearchParams(window.location.search).get("variant");
    if (fromUrl) return fromUrl;
    var input = document.querySelector('.product-form [name="id"]');
    if (input && input.value) return input.value;
    var option = document.querySelector(".product-form select option:checked");
    return option ? option.value : null;
  }

  // Fires before the theme swaps the visible media, so the swiper updates that
  // follow in switchImage() already see the corrected order.
  document.addEventListener("product:variant-change", function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (variant && variant.id) reorderForVariant(String(variant.id));
  });

  function init() {
    var id = currentVariantId();
    if (id) reorderForVariant(String(id));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
